var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoldArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.414L.586 10l4-4-4-4L2 .586l4.707 4.707a.999.999 0 010 1.414L2 11.414z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNyAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuOTk5OTcgMTEuNDE0TDAuNTg1OTY4IDEwTDQuNTg1OTcgNkwwLjU4NTk2OCAyTDEuOTk5OTcgMC41ODU5OTlMNi43MDY5NyA1LjI5M0M3LjA5Nzk3IDUuNjg0IDcuMDk3OTcgNi4zMTYgNi43MDY5NyA2LjcwN0wxLjk5OTk3IDExLjQxNFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgBoldArrowRight as ReactComponent };